<template>
    <div class="dashboard row">
        <div class="col-12 col-md-8">
            <div class="row">
                <div class="col-12">
                    <!--        Todo: Convert to actual tab!-->
                    <design-2021-dashboard-show-header-component
                        :filters="filters"
                        @change-filter="updateFilter"
                        :sorted-in="sorted"
                        @sorting-update="updateSorting"
                        :seasons-in="seasonsIn"
                        :group-unread-messages-count="groupUnreadMessagesCount"
                        :has-magazines="magazinesIn.length > 0"
                        :current-season-id="currentSeasonId"
                        :has-cards="cards.length >= 1"
                        ref="dashboardHeader">
                    </design-2021-dashboard-show-header-component>
                </div>

                <div class="col-12 dashboard-main-content">
                    <b-row v-if="cardsFiltered.length && !filters.messages">
                        <b-col
                            class="dashboard-card-wrapper"
                            v-for="card in cardsFiltered"
                            :cols="filters.magazines ? 8 : 12"
                            :offset="filters.magazines ? 2 : 0"
                            :offset-sm="filters.magazines ? 0 : 0"
                            md="6"
                            :xl="filters.magazines ? 3 : 4"
                            :class="filters.magazines && 'magazines'"
                            :key="card.id">
                            <design-2021-dashboard-digitalstudies-card-component
                                v-if="card.type === 'digitalstudies'"
                                :title="$t('dashboard.explain_videos')">
                            </design-2021-dashboard-digitalstudies-card-component>
                            <design-2021-dashboard-card-component
                                v-else
                                :card="card"
                                @reduce-unread-messages="reduceGroupUnreadMessages($event)"
                                @show-grade-modal="showModal">
                            </design-2021-dashboard-card-component>
                        </b-col>
                        <design-2021-dashboard-show-portfolio-grade-modal-component ref="grade-modal">
                        </design-2021-dashboard-show-portfolio-grade-modal-component>
                    </b-row>

                    <b-alert
                        :show="!cardsFiltered.length && filters.groups && !digitalStudiesAccess"
                        variant="info">
                        {{ $t('dashboard.no_projects_found_for_school_year', { school_year: selectedSeason }) }}
                    </b-alert>

                    <b-alert
                        :show="
                            !cardsFiltered.length &&
                            filters.projects &&
                            !digitalStudiesAccess &&
                            this.$authUser.isStudent()
                        "
                        variant="info">
                        {{ $t('dashboard.no_projects_found') }}
                    </b-alert>

                    <b-alert
                        :show="!cardsFiltered.length && filters.projects && !this.$authUser.isStudent()"
                        variant="info">
                        {{ $t('dashboard.no_projects_found') }}
                    </b-alert>

                    <b-alert
                        :show="!cardsFiltered.length && filters.magazines"
                        variant="info">
                        {{ $t('dashboard.no_magazines_found') }}
                    </b-alert>

                    <b-alert
                        :show="!messages.length && filters.messages"
                        variant="info">
                        {{ $t('dashboard.no_magazines_found') }}
                    </b-alert>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-4">
            <div class="dashboard-sidebar">
                <design-2021-dashboard-learning-path-widget-component
                    v-if="hasLearningPath && learningPathIn && $authUser.isStudent()"
                    :lp-assignments="lpAssignments">
                </design-2021-dashboard-learning-path-widget-component>
                <design-2021-dashboard-calendar-widget-component
                    v-if="$authUser.isTeacher() || $authUser.isStudent()"
                    :agenda-items-in="agendaItemsIn">
                </design-2021-dashboard-calendar-widget-component>

                <design-2021-dashboard-project-invites-widget-component
                    v-if="!$authUser.isAdmin()"
                    :invites-in="invitesIn"
                    :profile-choice-survey-users-in="profileChoiceSurveyUsers"
                    :survey-peers-in="surveyPeersIn"
                    :surveys-in="surveysIn"
                    :groups-in="groups"
                    :ar-skill-tree-invites-in="arSkillTreeInvitesIn"
                    :unfinished-test-responses-in="unfinishedTestResponsesIn">
                </design-2021-dashboard-project-invites-widget-component>

                <design-2021-dashboard-group-pair-status-component
                    v-if="$authUser.isStudent() && invitesPending.length"
                    :invites-in="invitesPending"></design-2021-dashboard-group-pair-status-component>

                <design-2021-dashboard-quick-options-component v-if="$authUser.isAdmin()">
                </design-2021-dashboard-quick-options-component>

                <design-2021-conference-dashboard-component
                    v-if="$authUser.isTeacher() || $authUser.isStudent()"
                    :conference-in="conferenceIn">
                </design-2021-conference-dashboard-component>

                <design-2021-dashboard-improve-us-widget-component v-if="!$authUser.isStudent()">
                </design-2021-dashboard-improve-us-widget-component>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-dashboard-show-component',
    props: {
        magazinesIn: Array,
        projects: {
            type: [Object, Array],
            default() {
                return {};
            },
        },
        groups: [Object, Array],
        seasonsIn: Array,
        messagesIn: {
            type: Array,
            required: false,
        },
        imageIn: Object,
        userCredentialsIn: Object,
        agendaItemsIn: Array,
        invitesIn: [Object, Array],
        profileChoiceSurveyUsers: [Object, Array],
        conferenceIn: Array,
        surveyPeersIn: Array,
        digitalStudiesAccess: Number,
        currentSeasonId: Number,
        surveysIn: {
            type: Array,
            default() {
                return [];
            },
        },
        learningPathIn: {
            type: Object,
            required: false,
            default() {
                return {};
            },
        },
        hasLearningPath: {
            type: Boolean,
            required: false,
            default() {
                return false;
            },
        },
        lpAssignments: {
            type: Array,
            required: false,
            default() {
                return [];
            },
        },
        arSkillTreeInvitesIn: {
            type: Array,
            required: false,
            default() {
                return [];
            },
        },
        groupsForGroupPairIn: {
            type: Array,
            required: false,
            default() {
                return [];
            },
        },
        unfinishedTestResponsesIn: {
            type: Array,
            required: false,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            cards: [],
            messages: this.messagesIn ? this.messagesIn : [],
            filters: {
                groups: false,
                projects: false,
                magazines: false,
                messages: false,
            },
            sorted: this.seasonsIn.some((season) => season.id === this.currentSeasonId)
                ? this.currentSeasonId
                : this.seasonsIn.length
                  ? this.seasonsIn[0].id
                  : null,
            selectedSeason: '',
            groupUnreadMessagesCount: 0,
            invitesPending: this.invitesIn.filter((invite) => invite.status === 3),
        };
    },

    methods: {
        reduceGroupUnreadMessages(data) {
            this.groupUnreadMessagesCount -= data.value;
        },

        updateFilter(selectedFilter) {
            for (const key of Object.keys(this.filters)) {
                if (key === selectedFilter) {
                    this.filters[key] = true;
                } else {
                    this.filters[key] = false;
                }
            }
        },

        updateSorting(sorting) {
            this.sorted = sorting;
            const seasonIndex = this.seasonsIn.map((season) => season.id).indexOf(sorting);
            if (seasonIndex !== -1) {
                this.selectedSeason = this.seasonsIn[seasonIndex].season;
            }
            const key = 'dasboard-show-selected-season-' + this.$authUser.id;
            localStorage.setItem(key, sorting);
        },

        roadmapSorted(group_roadmap, statuses) {
            let count_steps = group_roadmap && group_roadmap.steps ? group_roadmap.steps.length : 0;

            if (count_steps === 0) {
                return;
            }

            for (let step of group_roadmap.steps) {
                if (statuses.length !== 0) {
                    for (let status of statuses) {
                        if (status.roadmap_step_id === step.id) {
                            step.status = status.status;
                            step.finished = status.finished;
                        }
                    }
                }
            }

            return group_roadmap;
        },

        showModal(groupId) {
            // this.alert.loading();
            this.axios.get(this.routes.getGradeableGroupAssignments(groupId)).then(
                (response) => {
                    // this.alert.loaded();
                    this.$refs['grade-modal'].show(response.data);
                },
                (error) => {},
            );

            // let assignments = [];
            // const hasAccessToGrade = this.canGrade(groupId);
            // if(hasAccessToGrade) {
            //     const gradeAbleGroup = this.groups.filter(group => group.id === groupId);
            //     const projectId = this.projects.filter(project => project.group_id === groupId);
            //     if(gradeAbleGroup.length){
            //         for(const category of gradeAbleGroup[0].portfolios[0].categories){
            //             for(const assignment of category.assignments){
            //                 if(assignment.statuses.length){
            //                     const status = assignment.statuses.slice(-1);
            //                     if(status[0].finished === 1 && status[0].status === 1){
            //                         assignments.push({
            //                             id: assignment.id,
            //                             name: assignment.name,
            //                             project_id: projectId,
            //                             group_id: groupId,
            //                         })
            //                     }
            //                 }
            //             }
            //         }
            //     }
            // }
        },

        canGrade(groupId) {
            const gradeGroup = this.groups.filter((group) => group.id === groupId);
            if (gradeGroup.length) {
                for (const user of gradeGroup[0].users) {
                    if (parseInt(user.id) === parseInt(this.$authUser.id) || this.$authUser.isAdmin()) {
                        return true;
                    }
                }
            }
            return false;
        },

        isGroupAdmin(group) {
            const is_group_admin = group.users.some((user) => user.id === this.$authUser.id);
            const is_teacher_of_group = group.group_pair_teachers
                ? group.group_pair_teachers.some((groupTeacher) => groupTeacher.user_id === this.$authUser.id)
                : false;

            return is_group_admin && !is_teacher_of_group;
        },
    },

    mounted() {
        if (this.$authUser.isAdmin()) {
            if (this.groups.length) {
                this.filters.groups = true;
            } else if (this.magazinesIn.length) {
                this.filters.magazines = true;
            } else {
                this.filters.groups = true;
            }
        }

        if (this.$authUser.isStudent()) {
            if (this.projects.length) {
                this.filters.projects = true;
            } else if (this.magazinesIn.length) {
                this.filters.magazines = true;
            } else if (this.messages.length) {
                this.filters.messages = true;
            } else {
                this.filters.projects = true;
            }
        }

        if (this.$authUser.isTeacher()) {
            if (this.groups.length) {
                this.filters.groups = true;
            } else if (this.projects.length) {
                this.filters.projects = true;
            } else if (this.magazinesIn.length) {
                this.filters.magazines = true;
            } else if (this.messages.length) {
                this.filters.messages = true;
            } else {
                this.filters.groups = true;
            }
        }

        if (this.magazinesIn.length) {
            for (const magazine of this.magazinesIn) {
                this.cards.push({
                    id: magazine.id,
                    title: magazine.title,
                    type: 'magazine',
                    thumbnail: magazine.cover.lowres,
                    size: magazine.size,
                });
            }
        }

        if (this.projects.length) {
            for (const project of this.projects) {
                let thumbnail = null;
                let courseName = null;
                let season = null;
                let title = null;
                let type = null;
                let users = null;
                let endDate = null;
                let startDate = null;
                let season_id = null;
                let controller = null;
                let unread_messages_count = null;
                let banner = null;
                let roadmap = null;

                if (this.$authUser.isStudent()) {
                    thumbnail = project.group.course.image;
                    courseName = project.group.course.name;
                    season = project.group.season.season;
                    title = project.group.absolute_parent_title;
                    controller = project.type.controller;
                    users = project.users;
                    endDate = project.group.endDate;
                    startDate = project.group.startDate;
                    season_id = project.group.season_id;
                    unread_messages_count = project.messages_count + project.group.messages_count;
                    roadmap = this.roadmapSorted(project.group.group_roadmap, project.roadmap_step_project_statuses);
                } else {
                    thumbnail = project.group.course.image;
                    courseName = project.group.course.name;
                    season = project.group.season.season;
                    title = project.group.absolute_parent_title;
                    type = 'project';
                    users = project.users;
                    endDate = project.group.endDate;
                    startDate = project.group.startDate;
                    season_id = project.group.season.id;
                    controller = project.type.controller;
                    unread_messages_count = project.messages_count;
                    roadmap = this.roadmapSorted(project.group.group_roadmap, project.roadmap_step_project_statuses);
                }

                this.cards.push({
                    id: project.id,
                    title,
                    type: 'project',
                    thumbnail,
                    course: courseName,
                    season,
                    type_id: project.type_id,
                    users,
                    group_id: project.group_id,
                    endDate,
                    startDate,
                    season_id,
                    controller,
                    unread_messages_count: unread_messages_count,
                    banner: project.group.banner_hard, //to be fixed when we use Resources
                    roadmap,
                });
            }
        }

        for (const group of this.groups) {
            // for (const group of this.groups) {
            let thumbnail = null;
            let courseName = null;
            let season = null;
            let title = null;
            let type = null;
            let users = null;
            let endDate = null;
            let startDate = null;
            let season_id = null;
            let unread_messages_count = null;
            let banner = null;
            let is_group_admin = false;
            if (this.$authUser.isStudent()) {
                thumbnail = group.course.image;
                courseName = group.course.name;
                season = group.season.season;
                title = group.name;
                type = group.type.controller;
                users = group.users;
                endDate = group.endDate;
                startDate = group.startDate;
                season_id = group.season_id;
                unread_messages_count = group.messages_count + group.project_messages_count;
                banner = group.banner;
            } else {
                thumbnail = group.course.image;
                courseName = group.course.name;
                season = group.season.season;
                title = group.name;
                type = 'group';
                users = [];
                endDate = group.endDate;
                startDate = group.startDate;
                season_id = group.season_id;
                unread_messages_count = group.messages_count + group.project_messages_count;
                banner = group.banner;
                is_group_admin = this.isGroupAdmin(group);
            }

            this.cards.push({
                id: group.id,
                title,
                type,
                thumbnail,
                course: courseName,
                season,
                type_id: group.type_id,
                users,
                group_id: group.id,
                endDate,
                startDate,
                season_id,
                unread_messages_count: unread_messages_count,
                banner,
                is_group_admin,
            });
            // }
        }

        const key = 'dasboard-show-selected-season-' + this.$authUser.id;
        let sorted = this.sorted;
        const sortedStorage = parseInt(localStorage.getItem(key));

        if (sortedStorage && this.seasonsIn.some((season) => season.id === sorted)) {
            let sortedSeasonExists = this.seasonsIn.some((season) => season.id === sortedStorage);

            if (sortedSeasonExists) {
                sorted = sortedStorage;
            }
        }
        this.updateSorting(sorted);

        if (this.$authUser.isStudent()) {
            if (this.groupsForGroupPairIn.length) {
                this.filters.projects = true;

                for (const group of this.groupsForGroupPairIn) {
                    let thumbnail = null;
                    let courseName = null;
                    let season = null;
                    let title = null;
                    let users = null;
                    let endDate = null;
                    let startDate = null;
                    let season_id = null;
                    let controller = null;
                    let unread_messages_count = null;
                    let roadmap = null;

                    thumbnail = group.course.image;
                    courseName = group.course.name;
                    season = group.season.season;
                    title = group.name;
                    controller = null;
                    endDate = group.endDate;
                    startDate = group.startDate;
                    season_id = group.season_id;
                    unread_messages_count = group.messages_count;

                    this.cards.push({
                        id: group.id,
                        title,
                        type: 'groupPair',
                        thumbnail,
                        course: courseName,
                        season,
                        type_id: group.type_id,
                        users,
                        group_id: group.id,
                        endDate,
                        startDate,
                        season_id,
                        controller,
                        unread_messages_count: unread_messages_count,
                        banner: group.banner_hard, //to be fixed when we use Resources
                    });
                }
            }
        }

        for (const project of this.projects) {
            if (project.messages_count > 0) {
                this.groupUnreadMessagesCount += project.messages_count;
            }
        }
    },

    computed: {
        cardsFiltered() {
            let allCards = this.cards;
            //
            if (this.sorted && !this.filters.magazines) {
                allCards = allCards.filter((card) => {
                    if (card.season_id === this.sorted) {
                        return true;
                    }
                });
            }

            if (this.filters.magazines) {
                return allCards.filter((card) => card.type === 'magazine');
            }

            // als die op de projecten zit
            if (this.filters.projects) {
                let cards = allCards.filter((card) => card.type === 'project' || card.type === 'groupPair');

                if (
                    !!this.digitalStudiesAccess &&
                    this.$authUser.isStudent() &&
                    (!this.seasonsIn.length || this.seasonsIn[0].id === this.sorted)
                ) {
                    if (cards.length > 2) {
                        cards = [...cards.slice(0, 2), { type: 'digitalstudies' }, ...cards.slice(2)];
                    } else {
                        cards.push({ type: 'digitalstudies' });
                    }
                }

                return cards;
            }

            if (this.filters.groups) {
                let cards = allCards.filter((card) => card.type === 'group');

                if (!!this.digitalStudiesAccess && (!this.seasonsIn.length || this.seasonsIn[0].id === this.sorted)) {
                    if (allCards.length > 2) {
                        cards = [...cards.slice(0, 2), { type: 'digitalstudies' }, ...cards.slice(2)];
                    } else {
                        cards.push({ type: 'digitalstudies' });
                    }
                }

                return cards;
            }

            return allCards;
        },
    },
};
</script>

<style scoped lang="scss">
.dashboard-card-wrapper {
    margin-bottom: $grid-gutter-width;
}

.dashboard-sidebar {
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;

    > div {
        &:is(:first-child) {
            margin-top: 95px;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .dashboard-sidebar {
        max-width: 400px;
        margin-left: auto;
    }
}
</style>
